import {Fancybox} from "@fancyapps/ui";

const initLightBox = () => {
    Fancybox.bind("[data-fancybox]", {
        Thumbs: false,
        Slideshow: false
    });

    Fancybox.bind(".wp-block-gallery.is-style-slider .wp-block-image a", {
        Thumbs: false,
        Slideshow: false,
        Carousel: {
            transition: "slide",
        },
    });

    Fancybox.bind(".s-block-area .wp-block-image a", {
        Thumbs: false,
        Slideshow: false,
        Carousel: {
            transition: "slide",
        },
    });

    Fancybox.bind(".s-blocks .wp-block-image a", {
        Thumbs: false,
        Slideshow: false,
        Carousel: {
            transition: "slide",
        },
    });
}

export {initLightBox}
